import { StyledCloseIconSVG } from "./Icon.styles";
import { useCallback } from "react";

/**
 * CloseIconT1
 *
 * A clickable close‑icon SVG that invokes a callback when clicked, unless disabled.
 *
 * Params
 * - isDisabled (boolean): If true, click events are ignored.
 * - onClickCallback (function): Callback function to invoke on click.
 * - ...rest (object): Additional props forwarded to the SVG element.
 *
 * Returns
 * - React.ReactElement: The styled close‑icon SVG component.
 */

export const CloseIconT1 = ({ isDisabled = false, onClickCallback = () => {}, ...rest }) => {
  const handleClick = useCallback(
    e => {
      if (!isDisabled) {
        onClickCallback(e);
      }
    },
    [isDisabled, onClickCallback],
  );

  return <StyledCloseIconSVG {...rest} onClick={handleClick} />;
};
